<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="ExperienceEnum.Any" i18n>Indifférent</ng-container>
  <ng-container *ngSwitchCase="ExperienceEnum.Junior" i18n>Junior&nbsp;: 0&nbsp;-&nbsp;2&nbsp;ans</ng-container>
  <ng-container *ngSwitchCase="ExperienceEnum.Experienced" i18n
    >Expérimenté&nbsp;: 3&nbsp;-&nbsp;6&nbsp;ans</ng-container
  >
  <ng-container *ngSwitchCase="ExperienceEnum.Senior" i18n>Senior&nbsp;: 7&nbsp;ans et plus</ng-container>

  <ng-container *ngSwitchDefault>{{ model }}</ng-container>
</ng-container>
